const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "[::1]" ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export function register(config) {
  window.addEventListener("load", () => {
    if ("serviceWorker" in navigator) {
      registerValidSW(config);
    }
  });
}

export async function unregister() {
  // Offline access is off for this client, so any service worker still
  // registered from an earlier build would keep serving that build's cached
  // shell forever. Tear it down and drop the shell caches it left behind.
  if ("serviceWorker" in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      const hadWorker = registrations.length > 0;
      await Promise.all(registrations.map((r) => r.unregister()));

      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames
          .filter((name) => name.startsWith("ecollat-shell-"))
          .map((name) => caches.delete(name))
      );

      // The page is still controlled by the worker we just unregistered, so it
      // is running whatever that worker served. One reload lands on the network.
      if (hadWorker && navigator.serviceWorker.controller) {
        window.location.reload();
        return;
      }
    } catch (error) {
      console.error("Error while unregistering service worker:", error);
    }
  }

  var manifestLink = document.querySelector('link[rel="manifest"]');

  // Check if the link element exists before attempting to remove it
  if (manifestLink) {
    // Remove the link element from the DOM
    manifestLink.parentNode.removeChild(manifestLink);
  }
}

export const handleServiceWorker = () => {
  const usePreferences = window.__E_TT_Client || {};
  const hasAccess = usePreferences && usePreferences.offlineAccess;
  if (hasAccess === String(true)) {
    return registerValidSW();
  } else {
    return unregister();
  }
};

// new for microphone permission

// Check if the user has granted microphone permission
// if ('permissions' in navigator) {
// 	navigator.permissions.query({ name: 'microphone' }).then((permissionStatus) => {
// 		if (permissionStatus.state === 'granted') {
// 			// If the permission has been granted, revoke it
// 			permissionStatus.revoke();
// 		}
// 	});
// }

// remove microphone access permanently
if ("permissions" in navigator) {
  navigator.permissions
    .query({ name: "microphone" })
    .then((permissionStatus) => {
      if (permissionStatus.state === "granted") {
        permissionStatus.status = "denied";
      }
    });
}

// new for microphone permission

function registerValidSW(config) {
  // Whether this page load started out controlled by an existing worker. A
  // controller swap later means a new build took over, and the page is still
  // showing the old one.
  const startedControlled = Boolean(navigator.serviceWorker.controller);
  let reloading = false;

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!startedControlled || reloading) return;
    reloading = true;
    window.location.reload();
  });

  navigator.serviceWorker
    // updateViaCache: "none" stops the browser from answering the sw.js request
    // out of its HTTP cache, which otherwise hides a new worker for up to a day.
    .register(swUrl, { updateViaCache: "none" })
    .then((registration) => {
      registration.update().catch(() => { });

      // A tab left open across a deploy never re-registers, so re-check when the
      // user comes back to it.
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
          registration.update().catch(() => { });
        }
      });

      registration.onupdatefound = () => {

        const installingWorker = registration.installing;
        if (installingWorker == null) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {

            if (navigator.serviceWorker.controller) {
              if (config && config.onUpdate) config.onUpdate(registration);
            } else {
              if (config && config.onSuccess) config.onSuccess(registration);
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("Error during service worker registration:", error);
    });
}
